import React from "react";
import { object } from "prop-types";
import { StoryElement, WithLazy } from "@quintype/components";
import { isNonEmptyNode } from "../../../utils/story";

import "./big-image.m.css";

export const BigImage = ({ story, card }) => {
  const wideImageCard = card["story-elements"][0];
  const isGnreach = story?.["story-template"] === "gn-reach";
  const element = {
    "image-metadata": wideImageCard["image-metadata"],
    type: "image",
    "image-attribution": wideImageCard["image-attribution"],
    title: wideImageCard["title"],
    id: wideImageCard.id,
    "alt-text": wideImageCard["alt-text"],
    hyperlink: wideImageCard["hyperlink"],
    "image-s3-key": wideImageCard["image-s3-key"],
    metadata: wideImageCard.metadata,
    subtype: null,
  };
  return (
    <div
      className="story-element story-element-bg-image"
      styleName={`${isGnreach ? "gnreach-width big-image-wrapper" : "big-image-wrapper"}`}
    >
      <WithLazy margin="50px" key={element.id}>
        {() => (
          <StoryElement
            element={{
              ...element,
              "image-attribution": isNonEmptyNode(element["image-attribution"]) || element["image-attribution"],
              title: isNonEmptyNode(element.title) || element.title,
            }}
            key={element.id}
            loadIframeOnClick
          />
        )}
      </WithLazy>
    </div>
  );
};

BigImage.propTypes = {
  story: object,
};
